import React from 'react';
import classNames from 'classnames';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from './Header.scss';

interface BuilderHeaderProps {
  completed: boolean;
  completeIcon?: React.ReactElement<any>;
  defaultIcon?: React.ReactElement<any>;
  message?: string;
  savings?: string;
}

export type { BuilderHeaderProps };

const BuilderHeader = ({
  completed,
  completeIcon,
  defaultIcon,
  message,
  savings,
}: BuilderHeaderProps) => (
  <header
    className={classNames(styles.builderHeader, { [styles.completed]: completed })}
    data-testid="builder-header"
  >
    {completed ? completeIcon : defaultIcon}
    <div>
      <Typography element="h2" styleAs="sectionHeading" noMargins fixedSize>
        {message}
      </Typography>
      {savings && (
        <Typography
          className={styles.savings}
          data-testid="savings"
          noMargins
          styleAs="paragraphHeading"
        >
          {savings}
        </Typography>
      )}
    </div>
  </header>
);

BuilderHeader.displayName = 'BuilderHeader';

export default BuilderHeader;
